import { render, staticRenderFns } from "./view-handover-session.vue?vue&type=template&id=025d12df&"
import script from "./view-handover-session.vue?vue&type=script&lang=ts&"
export * from "./view-handover-session.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports